import React, {useEffect, useMemo, useState} from 'react';
import { useSelector } from 'react-redux';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { MultiSelect } from 'primereact/multiselect';
import * as Constants from "../../constants";
import B2BApiService from "../../B2bApiService";
import WriteAccessGuard from '../../components/reusableElementsComponents/WriteAccessGuard';
import { toast } from 'react-toastify';
import { t } from '../../content';

export default function AssignPoolsComp() {
  const reduxCompanyUsers = useSelector(state => state.company.users || []);

  const b2bServiceObj = useMemo(() => {
    return new B2BApiService();
  }, []);

  const [assignPools, setAssignPools] = useState({});
  const [changedRows, setChangedRows] = useState({});
  const [pools, setPools] = useState([]);
  const [users, setUsers] = useState([]);

  const handleMultiSelectPools = (e, userId) => {
    // Only pools with unique hashes should be selected
    const uniquePools = Array.from(new Set(e.value.map(pool => pool.hash)))
      .map(hash => e.value.find(pool => pool.hash === hash));

    setAssignPools((prevSelectedRoles) => ({
      ...prevSelectedRoles,
      [userId]: uniquePools,
    }));

    setChangedRows((prevChangedRows) => ({
      ...prevChangedRows,
      [userId]: true,
    }));

  };

  const assignedPoolsLabel = (count) =>
    t(count === 1 ? 'iam.poolsAssignedOne' : 'iam.poolsAssignedMany');

  const multiSelectPoolsTemplate = (rowData) => {
    const selectedCount = (assignPools[rowData.id] || []).length;
    return (
    <MultiSelect
      key={rowData?.id + '-pools'}
      value={assignPools[rowData.id] || []}
      options={pools}
      optionLabel='title'
      onChange={(e) => handleMultiSelectPools(e, rowData.id)}
      placeholder={t('iam.selectPools')}
      selectedItemsLabel={assignedPoolsLabel(selectedCount)}
      filter
      maxSelectedLabels={0}
    />
    );
  };

  const saveAssignedPools = (userId) => {
    let poolHashes = assignPools[userId].map(assignedPool => {
      const item = pools.find(item => item.hash === assignedPool.hash);
      return item ? item.hash : null;
    });

    b2bServiceObj.UpdateUserAccessToPools(userId, poolHashes,(res) => {
      if(res.httpStatus === 200){
        setChangedRows((prevChangedRows) => ({
          ...prevChangedRows,
          [userId]: false,
        }));

        toast.success(
          t('iam.toasts.assignPoolsSuccess'),
          {
            containerId: "IAMToast",
          }
        );
      } else {
        toast.error(
          t('iam.toasts.assignPoolsError'),
          {
            containerId: "IAMToast",
          }
        );
      }
    })
  }

  const actionTemplate = (rowData) => (
    <WriteAccessGuard>
      <button 
        className={changedRows[rowData.id] ? 'mazhrBtn default-green color-blink' : 'mazhrBtn default-green'} 
        onClick={() => saveAssignedPools(rowData.id)}
        >{t('common.actions.saveShort')}</button>
    </WriteAccessGuard>
  );
  const columns = [
    { field: 'name', header: t('common.labels.name') },
    { field: 'email', header: t('common.fields.email') },
    { field: 'role_id', header: t('common.labels.role'), body: (rowData) => Constants.getUserRoleStringByRoleId(rowData.role_id) },
    { field: 'multiSelectTeams', header: t('iam.assignedPools'), body: multiSelectPoolsTemplate },
    { field: 'action', header: t('common.labels.actions'), body: actionTemplate },
  ];

  useEffect(() => {
    b2bServiceObj.LoadPoolsWithIdAndTitle((data) => {
      setPools(data);
    })
  }, [b2bServiceObj]);

  useEffect(() => {
    // Check if reduxCompanyUsers is not empty. If not, use it to set users state. Otherwise, fetch from server.
    if (reduxCompanyUsers && reduxCompanyUsers.length > 0 && reduxCompanyUsers[0].hasOwnProperty('id')) {
      setUsers(reduxCompanyUsers.filter((user) => [Constants.USER_ROLE_TEAMLEAD, Constants.USER_ROLE_MANAGER].includes(user.role_id)));  
    }
  }, [b2bServiceObj, reduxCompanyUsers]);

  useEffect(() => {
    // Initialize assignPools state with the pool titles for each user
    let initialAssignPools = {};
    users.forEach(user => {
      initialAssignPools[user.id] = user.pool_hashes.map(hash => {
        const pool = pools.find(t => t.hash === hash);
        return pool ? pool : null;
      }).filter(pool => pool !== null);
    });
    setAssignPools(initialAssignPools);
  }, [users, pools]);

  return (
    <div className="user-list-wrapper-div">
      <div className="margin-left-div">
        <div className="user-list-inner-div">
          <DataTable value={users} paginator rows={10} rowsPerPageOptions={[10, 15, 20]}
            emptyMessage={t('iam.emptyAssignPools')}>
            {columns.map((column, i) => (
              <Column key={i} field={column.field} header={column.header} body={column.body} />
            ))}
          </DataTable>
        </div>
      </div>
    </div>
  );
}
